export const parseExchangeRate = (raw) => {
  if (raw === '' || raw == null) return null;
  const n = parseFloat(raw);
  return Number.isFinite(n) && n > 0 ? n : null;
};

/** Parse money-like values: numbers, "12,5", "£40", "$9.99". Empty → null. */
export const parseMoneyAmount = (raw) => {
  if (raw == null || raw === '') return null;
  if (typeof raw === 'number' && Number.isFinite(raw) && raw >= 0) return raw;
  const s = String(raw).trim();
  if (!s) return null;
  const cleaned = s.replace(/\s/g, '').replace(',', '.').replace(/[£$€₴]/g, '');
  const num = parseFloat(cleaned);
  if (Number.isFinite(num) && num >= 0) return num;
  const match = s.match(/(\d+(?:[.,]\d+)?)/);
  if (!match) return null;
  const fallback = parseFloat(match[1].replace(',', '.'));
  return Number.isFinite(fallback) && fallback >= 0 ? fallback : null;
};

export const hasPositiveMoney = (raw) => {
  const n = parseMoneyAmount(raw);
  return n != null && n > 0;
};

export const convertForeignToUah = (amount, rate) => {
  if (amount == null || rate == null || rate <= 0) return 0;
  return Math.ceil(amount * rate);
};

export const convertPoundsToUah = (priceInPounds, poundRate) =>
  convertForeignToUah(priceInPounds, poundRate);

export const convertUsdToUah = (priceInUsd, dollarRate) =>
  convertForeignToUah(priceInUsd, dollarRate);

export const convertEuroToUah = (priceInEuro, euroRate) =>
  convertForeignToUah(priceInEuro, euroRate);
